import React, { forwardRef, memo } from 'react'

const DocumentIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      stroke="#78BE20"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <circle
        cx={28}
        cy={28}
        r={26.871}
        fill="#fff"
        stroke="#eee"
        strokeWidth={2.259}
      />
      <path d="M23.8 25.9h8.4" />
      <path d="M23.8 28.7h8.4" />
      <path d="M19.6 35V21.7c0-.185.082-.363.229-.51a.72.72 0 0 1 .51-.229H35.7c.186 0 .364.082.511.229.147.147.229.325.229.51V35l-2.84-1.4-2.8 1.4-2.8-1.4-2.8 1.4-2.8-1.4-2.8 1.4Z" />
    </svg>
  )
)

DocumentIcon.displayName = 'DocumentIcon'
export default memo(DocumentIcon)
